export const MSHanswers = {
    0: "No Appointment Needed",
    1: "Medication",
    2: "Therapy",
    3: "Peer Services",
    4: "Case Management"
}